import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { globalRegions, Question } from 'altru-types';
import getQuestion from '@/store/questions/api';

@Module({ namespaced: true })
export default class QuestionModule extends VuexModule {
  question: Question = { asker_id: 0, id: -1, text: '' };

  get questionInfo(): Question {
    return this.question;
  }

  @Mutation
  setQuestionFromQuery(question: Question): void {
    this.question = question;
  }

  @Action
  async getQuestion({ questionId, region = 'us' }: { questionId: string; region: globalRegions }): Promise<Question> {
    try {
      const question = await getQuestion({ questionId, region });
      this.context.commit('setQuestionFromQuery', question);
      return question;
    } catch (e) {
      return e.response;
    }
  }
}
